import React from 'react';
import {
  SecurityVerification,
  RequesterInformation,
  VerificationSuccess,
} from '..';

interface Step {
  [key: number]: () => JSX.Element;
}

interface StepsStatus {
  [key: number]: Step;
}

export const stepsObject: StepsStatus = {
  3: {
    0: (): JSX.Element => <SecurityVerification />,
    1: (): JSX.Element => <RequesterInformation />,
    2: (): JSX.Element => <VerificationSuccess />,
  },
  4: {
    0: (): JSX.Element => <SecurityVerification />,
    1: (): JSX.Element => <RequesterInformation />,
    2: (): JSX.Element => <VerificationSuccess />,
  },
};
